import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="container-padding mx-auto">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          {/* 404 Number */}
          <div className="relative">
            <h1 className="font-display text-9xl sm:text-[12rem] font-bold text-primary/10">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-32 h-32 bg-accent rounded-full flex items-center justify-center">
                <i className="fas fa-balance-scale text-accent-foreground text-5xl"></i>
              </div>
            </div>
          </div>

          {/* Error Message */}
          <div className="space-y-4 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary">
              Página Não Encontrada
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Desculpe, a página que você está procurando não existe ou foi movida. 
              Volte para a página inicial ou entre em contato conosco para obter ajuda.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button
              asChild
              size="lg"
              className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-lg"
            >
              <Link to="/">
                <i className="fas fa-home mr-2"></i>
                Voltar para Home
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold px-8"
            >
              <Link to="/contato">
                <i className="fas fa-envelope mr-2"></i>
                Entre em Contato
              </Link>
            </Button>
          </div>

          {/* Quick Links */}
          <div className="pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground mb-4">Links Rápidos:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/sobre-nos"
                className="text-accent hover:text-accent-hover font-medium transition-colors"
              >
                Sobre Nós
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link
                to="/servicos"
                className="text-accent hover:text-accent-hover font-medium transition-colors"
              >
                Serviços
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link
                to="/artigos"
                className="text-accent hover:text-accent-hover font-medium transition-colors"
              >
                Artigos
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link
                to="/calculadora"
                className="text-accent hover:text-accent-hover font-medium transition-colors"
              >
                Calculadora
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
